import Button from './Button';

export default Button;
export { Button };
export type { ButtonProps, ButtonSize, ButtonType } from './type';
